import axios from "axios";

export const baseApi = axios.create({
    baseURL: `${import.meta.env.VITE_BACKEND_URL}/api/contramatic`
});

export const externalBaseApi = axios.create({
    baseURL: `${import.meta.env.VITE_BACKEND_URL}/ExternalData/api/contramatic`
});

export const extractData = response => response.data;

function getRequestContext(error) {
    return {
        pathname: window.location.pathname,
        search: window.location.search,
        method: error.config?.method?.toUpperCase(),
        url: error.config?.url,
        baseURL: error.config?.baseURL,
        params: error.config?.params,
        data: error.config?.data,
        userName: localStorage.getItem("userName"),
        timestamp: new Date().toISOString()
    };
}

function logAxiosError(error) {
    const context = getRequestContext(error);

    console.group("Axios Request Failed");

    if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Response:", error.response.data);
        console.error("Headers:", error.response.headers);
    } else if (error.request) {
        console.error("No response received.");
        console.error(error.request);
    } else {
        console.error("Request setup error:", error.message);
    }

    console.error("Context:", context);

    console.groupEnd();
}

baseApi.interceptors.request.use(config => {
    const token = localStorage.getItem("token");
    const userName = localStorage.getItem("userName");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    if (userName) {
        config.headers["X-App-User"] = userName;
    }

    return config;
});

baseApi.interceptors.response.use(
    response => response,
    error => {
        logAxiosError(error);
        return Promise.reject(error);
    }
);

// import axios from "axios";
//
// axios.interceptors.request.use(config => {
//
//     const token = localStorage.getItem('token');
//     const userName = localStorage.getItem('userName');
//
//     if (token) {
//         config.headers.Authorization = 'Bearer ' + token;
//     }
//
//     if (userName) {
//         config.headers['X-App-User'] = userName;
//     }
//
//     return config;
// });